import { render, staticRenderFns } from "./medicalObject.vue?vue&type=template&id=24b744f0&scoped=true&"
import script from "./medicalObject.vue?vue&type=script&lang=js&"
export * from "./medicalObject.vue?vue&type=script&lang=js&"
import style0 from "./medicalObject.vue?vue&type=style&index=0&id=24b744f0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b744f0",
  null
  
)

component.options.__file = "medicalObject.vue"
export default component.exports